import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/dave/checkouts/pyohio/static-website/node_modules/gatsby-theme-catalyst-core/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Seo = makeShortcode("Seo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Seo title="Attend PyOhio" mdxType="Seo" />
    <h1 {...{
      "id": "virtual-attendance"
    }}>{`Virtual Attendance`}</h1>
    <p>{`PyOhio 2021 will be a virtual event including streaming talks and conversation via Discord.
After `}<a parentName="p" {...{
        "href": "/2021/participate/register"
      }}>{`registering`}</a>{` you will receive instructions for getting connected to our Discord server.
We’ll have more details about discussion channels in the server readme once you join.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      